'use client';

export default function customImageLoader({ src, width, quality }) {
  /**
   * CPlat team implemented an image optimization service inside Wordpress called Tachyon.
   * It is a service that automatically optimize images based on query parameters in the URL.
   * More info: https://github.com/NerdWallet/article-client-next/blob/025ba22ae411f16215d918857b438ba4b0179437/scripts/image-loader.mjs#L16-L19
   */
  if (src.includes('assets/blog/wp-content/uploads')) {
    if (width !== undefined) {
      const tachyonUrl = src.replace(
        'assets/blog/wp-content/uploads',
        'tachyon'
      );
      const imageUrl = `${tachyonUrl}?w=${width}&q=${quality || 75}`;
      return imageUrl;
    }
  }

  // Send non relative urls directly to the source.
  if (src.startsWith('http')) {
    return src;
  }

  // Bypass optimization for SVGs (serve directly)
  if (src.endsWith('.svg')) {
    return src;
  }

  // Use NextJS image optimization API for relative urls.
  return `/landing-page-client/_next/image?url=${src}&w=${width}&q=${
    quality || 75
  } `;
}
